// import { useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';

// /**
//  * Custom hook to intercept the native Android/browser back button.
//  * It forces the navigation to use the react-router history instead of closing the app.
//  * * @param {function} customBackAction Optional function to execute instead of history.back()
//  */
// export const useAndroidBackHandler = (customBackAction) => {
//     const navigate = useNavigate();

//     useEffect(() => {
//         const handlePopState = () => {
//             // Check if a custom action is provided and execute it.
//             if (customBackAction) {
//                 customBackAction();
//             } else {
//                 // Default action: use react-router's history mechanism to go back.
//                 // This is generally safer than window.history.back() inside a PWA/Webview.
//                 navigate(-1);
//             }

//             // A crucial step: Re-add the current state to the history stack.
//             // This prevents the native back button from closing the app on the next press,
//             // as the history stack will always appear non-empty to the Android system.
//             window.history.pushState(null, '', window.location.href);
//         };

//         // Add the listener for the 'popstate' event (triggered by native back operation)
//         window.addEventListener('popstate', handlePopState);
        
//         // Push an initial state to the history to create the first entry.
//         // This is essential so the native back button doesn't close the app on the very first page.
//         // We do this inside the useEffect to ensure it runs only on mount.
//         window.history.pushState(null, '', window.location.href);

//         return () => {
//             // Clean up the event listener when the component unmounts
//             window.removeEventListener('popstate', handlePopState);
//         };
//     }, [navigate, customBackAction]);
// };


// import { useEffect, useRef } from 'react';
// import { Capacitor } from '@capacitor/core';
// import { App } from '@capacitor/app';

// export const useBackHandler = (activeScreen, navigateToScreen) => {
//   const lastBackPress = useRef(0);

//   useEffect(() => {

//     // ============================
//     // 📱 ANDROID (CAPACITOR)
//     // ============================
//     if (Capacitor.isNativePlatform()) {
//       const handler = App.addListener('backButton', () => {

//         switch (activeScreen) {
//           case 'checkoutView':
//             navigateToScreen('marketplaceProductView');
//             return;

//           case 'marketplaceProductView':
//             navigateToScreen('orders');
//             return;

//           case 'paymentEBillProviderDetails':
//             navigateToScreen('paymentebill');
//             return;

//           case 'paymentebill':
//             navigateToScreen('payment');
//             return;

//           case 'order':
//           case 'kycupdate':
//             navigateToScreen('profile');
//             return;

//           case 'meter_application':
//           case 'active_application':
//             navigateToScreen('home');
//             return;

//           case 'home': {
//             // 🔒 Double back to exit
//             const now = Date.now();
//             if (now - lastBackPress.current < 2000) {
//               App.exitApp();
//             } else {
//               lastBackPress.current = now;
//             }
//             return;
//           }

//           default:
//             navigateToScreen('home');
//             return;
//         }
//       });

//       return () => handler.remove();
//     }

//     // ============================
//     // 🌐 BROWSER / PWA FALLBACK
//     // ============================
//     const handlePopState = () => {
//       navigateToScreen('home');
//     };

//     window.addEventListener('popstate', handlePopState);
//     return () => window.removeEventListener('popstate', handlePopState);

//   }, [activeScreen, navigateToScreen]);
// };



import { useEffect, useRef } from 'react';
import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';


// Global reference to the custom back handler function (handleBack in PayEBillProviderDetails)
let customNativeBackHandler = null; 

export const setCustomNativeBackHandler = (handler) => {
    customNativeBackHandler = handler;
};

export const clearCustomNativeBackHandler = () => {
    customNativeBackHandler = null;
};

export const useBackHandler = (activeScreen, navigateToScreen) => {
  const lastBackPress = useRef(0);

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    const handler = App.addListener('backButton', () => {


      // 🛑 NEW LOGIC: Check for and execute a custom handler
            if (customNativeBackHandler) {
                // If a child component registered a custom handler (like PayEBillProviderDetails's step logic)
                customNativeBackHandler();
                return;
            }
      // 🚫 IMPORTANT: Let child flows handle their own back
      if (
        activeScreen === 'checkoutView' ||
        activeScreen === 'marketplaceProductView'
      ) {
        return;
      }

      switch (activeScreen) {
        // case 'paymentEBillProviderDetails':
        //   navigateToScreen('paymentebill');
        //   return;

        // case 'paymentebill':
        //   navigateToScreen('payment');
        //   return;

        case 'order':
        case 'kycupdate':
          navigateToScreen('profile');
          return;

        case 'meter_application':
        case 'active_application':
          navigateToScreen('home');
          return;

        case 'home': {
          const now = Date.now();
          if (now - lastBackPress.current < 2000) {
            App.exitApp();
          } else {
            lastBackPress.current = now;
          }
          return;
        }

        default:
          navigateToScreen('home');
          return;
      }
    });

    return () => handler.remove();
  }, [activeScreen, navigateToScreen]);
};
